<template lang="pug">
  .page
    .max-width
      .row
        .col.max
          router-view
        .col
          aside
            nav
              h6 You
              router-link(:to="{ name: 'UserSettingsAccount' }") Account
              router-link(:to="{ name: 'UserSettingsChangePassword' }") Change Password
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'SettingsLayout',
  beforeMount () {
    this.$store.dispatch('getPlans')
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  nav
    h6
      padding $spacing $spacing-2
    a
      display block
      padding $spacing-2
      &.router-link-exact-active
        background-color $background-active
    hr
      border none
      border-top $border-default
      margin 0
  aside
    border $border-default
    border-radius $border-radius
    margin-left $spacing-3
    width 370px

</style>